(function () {
  var root = document.querySelector('[data-pz-root]');
  if (!root) return;

  function wrapEvery15(text) {
    var words = text.split(' ');
    var lines = [];
    var current = '';
    words.forEach(function (word) {
      if (current === '') {
        current = word;
      } else if ((current + ' ' + word).length <= 30) {
        current += ' ' + word;
      } else {
        lines.push(current);
        current = word;
      }
    });
    if (current) lines.push(current);
    return lines.slice(0, 3).join('\n');
  }


  var trigger = document.querySelector('[data-pz-trigger]');
  var overlay = document.querySelector('[data-pz-overlay]');
  var closeBtn = root.querySelector('[data-pz-close]');

  document.body.appendChild(overlay);
  document.body.appendChild(root);

  var lockedScrollY = 0;

  function getCurrentVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var input = form && (form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'));
    return (input && input.value) || state.mainVariantId;
  }

  function syncVariant() {
    var freshId = getCurrentVariantId();
    if (!freshId || freshId === state.mainVariantId) return;
    state.mainVariantId = freshId;
    fetch(window.location.pathname + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var variant = data.variants.find(function (v) { return String(v.id) === String(freshId); });
        if (variant) {
          state.basePrice = variant.price / 100;
          updateTotal();
        }
      });
  }

  function openDrawer() {
    lockedScrollY = window.scrollY;
    syncVariant();
    root.style.visibility = 'visible';
    root.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedScrollY + 'px';
    document.body.style.width = '100%';
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
    setTimeout(function () {
      root.style.visibility = 'hidden';
    }, 250);
  }

  trigger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  var state = {
    mainVariantId: root.dataset.mainVariantId,
    basePrice: parseFloat(root.dataset.basePrice),
    bothsides: false,
    priority: false,
    review: true,
    note: false
  };

  var addons = {
    bothsides: { id: root.dataset.bothsidesVariantId, price: parseFloat(root.dataset.bothsidesPrice) },
    priority: { id: root.dataset.priorityVariantId, price: parseFloat(root.dataset.priorityPrice) },
    review: { id: root.dataset.reviewVariantId, price: parseFloat(root.dataset.reviewPrice) },
    note: { id: root.dataset.noteVariantId, price: parseFloat(root.dataset.notePrice) }
  };

  function formatMoney(amount) {
    return amount.toFixed(2).replace('.', ',') + '€';
  }

  var engraveOuterInput = root.querySelector('[data-pz-field="engrave-outer"]');
  var engraveInnerInput = root.querySelector('[data-pz-field="engrave-inner"]');
  var engraveInnerGroup = root.querySelector('[data-pz-engrave-inner]');
  var previewWrapOuter = root.querySelector('[data-pz-preview-wrap="outer"]');
  var previewWrapInner = root.querySelector('[data-pz-preview-wrap="inner"]');
  var previewTextOuter = root.querySelector('[data-pz-preview="outer"]');
  var previewTextInner = root.querySelector('[data-pz-preview="inner"]');

  function updatePreview(which) {
    if (which === 'outer' || !which) {
      var textOuter = engraveOuterInput.value.trim();
      previewTextOuter.textContent = wrapEvery15(textOuter);
      previewWrapOuter.hidden = textOuter.length === 0;
    }
    if (which === 'inner' || !which) {
      var textInner = engraveInnerInput.value.trim();
      previewTextInner.textContent = wrapEvery15(textInner);
      previewWrapInner.hidden = !state.bothsides || textInner.length === 0;
    }
  }

  document.querySelectorAll('[data-pz-pills]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.pz__pill');
      if (!btn) return;
      group.querySelectorAll('.pz__pill').forEach(function (p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var kind = group.dataset.pzPills;
      var value = btn.dataset.value;

      if (kind === 'font') {
        previewTextOuter.style.fontFamily = btn.style.fontFamily;
        previewTextInner.style.fontFamily = btn.style.fontFamily;
      }
      if (kind === 'size') {
        var currentEl = document.querySelector('[data-pz-size-current]');
        if (currentEl) currentEl.textContent = btn.dataset.short || value;
      }

      updateTotal();
    });
  });

  engraveOuterInput.addEventListener('input', function () {
    root.querySelector('[data-pz-charcount="outer"]').textContent = engraveOuterInput.value.length + '/90';
    updatePreview('outer');
  });

  engraveInnerInput.addEventListener('input', function () {
    root.querySelector('[data-pz-charcount="inner"]').textContent = engraveInnerInput.value.length + '/90';
    updatePreview('inner');
  });

  var bothsidesToggle = root.querySelector('[data-pz-toggle="bothsides"]');
  bothsidesToggle.addEventListener('change', function () {
    state.bothsides = bothsidesToggle.checked;
    engraveInnerGroup.hidden = !state.bothsides;
    if (!state.bothsides) {
      engraveInnerInput.value = '';
      root.querySelector('[data-pz-charcount="inner"]').textContent = '0/90';
    }
    updatePreview('inner');
    updateTotal();
  });

  var priorityToggle = root.querySelector('[data-pz-toggle="priority"]');
  priorityToggle.addEventListener('change', function () {
    state.priority = priorityToggle.checked;
    updateTotal();
  });

  var reviewToggle = root.querySelector('[data-pz-toggle="review"]');
  reviewToggle.addEventListener('change', function () {
    state.review = reviewToggle.checked;
    updateTotal();
  });

  var noteToggle = root.querySelector('[data-pz-toggle="note"]');
  noteToggle.addEventListener('change', function () {
    state.note = noteToggle.checked;
    updateTotal();
  });

  function updateTotal() {
    var total = state.basePrice;
    if (state.bothsides) total += addons.bothsides.price;
    if (state.priority) total += addons.priority.price;
    if (state.review) total += addons.review.price;
    if (state.note) total += addons.note.price;
    root.querySelector('[data-pz-total]').textContent = formatMoney(total);
  }


  var errorEl = root.querySelector('[data-pz-error]');
  var submitBtn = root.querySelector('[data-pz-submit]');

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  submitBtn.addEventListener('click', function () {
    errorEl.hidden = true;
    var engraveOuter = engraveOuterInput.value.trim();
    var engraveInner = engraveInnerInput.value.trim();
    if (!engraveOuter) {
      showError('Συμπλήρωσε το κείμενο χάραξης.');
      engraveOuterInput.focus();
      return;
    }
    if (state.bothsides && !engraveInner) {
      showError('Συμπλήρωσε το κείμενο χάραξης για τη 2η πλευρά.');
      engraveInnerInput.focus();
      return;
    }
    var sizeActiveEl = document.querySelector('[data-pz-pills="size"] .is-active');
    var properties = {
      'Επιλογή Γραμματοσειράς': root.querySelector('[data-pz-pills="font"] .is-active').dataset.value,
      'Χάραξη': engraveOuter,
      'Παρατηρήσεις - Σχόλια': root.querySelector('[data-pz-field="notes"]').value.trim()
    };
    if (sizeActiveEl) properties['Επιλογή Μεγέθους'] = sizeActiveEl.dataset.value;
    if (state.bothsides) properties['Επιπλέον Χάραξη - 2η Πλευρά'] = engraveInner;

    var items = [];
    items.push({
      id: getCurrentVariantId(),
      quantity: 1,
      properties: properties
    });

    if (state.bothsides) items.push({ id: addons.bothsides.id, quantity: 1 });
    if (state.priority) items.push({ id: addons.priority.id, quantity: 1 });
    if (state.review) items.push({ id: addons.review.id, quantity: 1 });
    if (state.note) items.push({ id: addons.note.id, quantity: 1 });

    submitBtn.disabled = true;
    submitBtn.textContent = 'Προσθήκη...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart-add-failed');
        return r.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        showError('Κάτι πήγε στραβά. Δοκίμασε ξανά.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Προσθήκη στο Καλάθι';
      });
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Προσθήκη στο Καλάθι';
      errorEl.hidden = true;
    }
  });

  updateTotal();
})();
